import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { MaterialModal } from 'components/layout'
import MfaCode from '../../../containers/forms/dashboard/SetMfaCode/MfaCode'
import PropTypes from 'prop-types'

export default class MfaCodeModal extends Component {
  static propTypes = {
    modalId: PropTypes.string
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title={
          <FormattedMessage
            id="title.insert_code_from_authenticator"
            defaultMessage="Insert code from the authenticator"
          />
        }
      >
        <MaterialModal.Content>
          <MfaCode />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
